import { AccountProductEnum } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import React from 'react';
import ListItem from 'shared/components/vxl/ListItem/ListItem';

interface StatementsListItemProps {
  title: string;
  accountId: string;
  analyticsId: string;
  accountType?: string;
}

const StatementsListItem = ({
  title,
  accountId,
  analyticsId,
  accountType,
}: StatementsListItemProps) => {
  const router = useRouter();
  return (
    <ListItem
      primaryCopy={title}
      analyticsId={analyticsId}
      customAttributes={
        accountType === AccountProductEnum.ChargeCard.toLowerCase()
          ? { category: 'varo_believe' }
          : { category: accountType || null }
      }
      onPress={() => {
        router.push({
          pathname: `/myvaro/statements-and-forms/account-statements/[id]`,
          params: { id: accountId },
        });
      }}
    />
  );
};

export default StatementsListItem;
